'use client'

import Link from 'next/link'
import { cn } from '@nwwp/ui-shadcn'

const DEFAULT_MESSAGE = 'More questions? Book a free call with a financial advisor →'

type ScheduleStickyBarProps = {
  onDismiss: () => void
  /** Final href (caller applies tracking). */
  href: string
  message?: string
  className?: string
  dismissLabel?: string
}

/** Mobile-only fixed bottom schedule CTA for self-serve tools. */
export function ScheduleStickyBar({
  onDismiss,
  href,
  message = DEFAULT_MESSAGE,
  className,
  dismissLabel = 'Close',
}: ScheduleStickyBarProps) {
  return (
    <div
      className={cn(
        'dark fixed inset-x-0 bottom-0 z-100 flex items-center gap-3 bg-card p-4 shadow-[0_-4px_20px_rgba(0,0,0,0.2)] tablet:hidden',
        className
      )}
    >
      <Link href={href} className="flex-1 text-body-sm leading-snug font-semibold text-white no-underline">
        {message}
      </Link>
      <button
        type="button"
        onClick={onDismiss}
        aria-label={dismissLabel}
        className="shrink-0 border-none bg-transparent px-1 leading-none text-white/40 hover:text-white"
      >
        ✕
      </button>
    </div>
  )
}
